import app from '../authentication/firebaseStart';

import { TimeZoneData } from "../data/tzTimeZoneList";
import {covertIPToNumber} from '../utils/SiteSession';

export class SiteModel {

  siteName;

  timeZone;

  scheduledReportTime;

  emailSubscribed;

  emailList;

}

export class SiteService {


  firestore = app.firestore();


  getDBValue(value, toUpperCase = true) {
    //Values should be saved as UPPERCASE in DB.
    if (value == null) {
      return "";
    }
    else {
      //Values should be saved as UPPERCASE in DB if toUpperCase is passed
      return (toUpperCase) ? value.toUpperCase() : value;
    }

  }


  async setSiteInfoUpdated(tenantId, site) {
    var timestamp = Date.now();

    var options = {
      mergeFields: [
        "siteInfoUpdated"
      ]
    };
    await this.firestore
      .collection("tenants")
      .doc(tenantId)
      .collection("SiteLocations").doc(site).set({
        "siteInfoUpdated": timestamp
      }, options);

  }


  async setSiteAPSUpdated(tenantId, site) {
    var timestamp = Date.now();

    var options = {
      mergeFields: [
        "siteApsUpdated"
      ]
    };


    await this.firestore
      .collection("tenants")
      .doc(tenantId)
      .collection("SiteLocations").doc(site).set({
        "siteApsUpdated": timestamp
      }, options);

  }

  getUTCTime = (timeZone, hrs, mins) => {

    const getTimezoneOffset = (timeZone, date = new Date()) => {
      const tz = date.toLocaleString("en", { timeZone, timeStyle: "long" }).split(" ").slice(-1)[0];
      const dateString = date.toString();
      //Fetched the UTCStd from Timezonelist file, as Date.parse is not supporting some timezones
      var timeZoneUTCStd = this.getDBTimeZoneData(timeZone).utcStd;
      const offset = Date.parse(`${dateString} UTC`) - Date.parse(`${dateString} ${timeZoneUTCStd}`);
      //const offset = Date.parse(`${dateString} UTC`) - Date.parse(`${dateString} ${tz}`);
      // return UTC offset in millis
      return offset;
    }

    const hrMil = 3600000;
    const minMil = 60000

    var miSec = ((hrs * hrMil) + (mins * minMil)) - getTimezoneOffset(timeZone);
    var min = Math.floor((miSec / 1000 / 60) % 60)
    var hr = Math.floor((miSec / 1000 / 60 / 60) % 24)
    //console.log(min, hr, 'min,hr')
    if (min < 0) min += 60
    if (hr < 0) hr += 24

    const utcTime = { min: min, hr: hr }
    return utcTime
  }

  async addSite(tenantId, site) {
    let schReportTimeHrs = 0;
    let schReportTimeMts = 0;
    var utcTime = {};
    utcTime.hr = 0;
    utcTime.min = 0;
    if(site?.scheduledReportTime !== null) {
      schReportTimeHrs = site?.scheduledReportTime?.hrs;
      schReportTimeMts = site?.scheduledReportTime?.minutes
    }
      if(site.scheduledReportTime !== null) {
        utcTime = this.getUTCTime(site.timeZone, schReportTimeHrs, schReportTimeMts)
      }
      let email_categories = "";
      if(site.snapshotReportCategories['Select All'] == true)   // If select all is chosen
      {
        email_categories = "All";
      }
      else
      {
        for(let key in site.snapshotReportCategories){
          let value = site.snapshotReportCategories[key];
          if(value){
            email_categories = email_categories + key + ",";
          }
        }
        email_categories = email_categories.substring(0,email_categories.length - 1);
      }
      if(email_categories === "")   // if no categories are chosen
      {
        email_categories = "Default";
      }

    //DocumentId will be MAC ADRRESS
    var documentId = site.siteName;
    documentId = documentId.toUpperCase();

    //Use merge option to merge the existing document if it exist
    var options = { merge: true };

    //console.log('utcTime',utcTime);
    //console.log('site.scheduledReportTime',site.scheduledReportTime);
    //console.log('schReportTimeMts',schReportTimeMts);
    var reportedTime = this.convertToCRON(site.scheduledReportTime);
    //console.log('reportedTime',reportedTime);
    var timeZone = this.getDBTimeZoneData(site.timeZone);
    await this.firestore
      .collection("tenants")
      .doc(tenantId)
      .collection("SiteLocations").doc(documentId).set({
        siteName: this.getDBValue(site.siteName),
        displaySiteName: site.siteName,
        timeZone: this.getDBValue(site.timeZone,false),
        reportHoursActual: schReportTimeHrs,
        reportMinutesActual: schReportTimeMts,
        reportUTCHours: utcTime.hr,
        reportUTCMinutes: utcTime.min,
        dstObserved: timeZone.dst,
        attachCSV: site.attachCSV,
        snapshotReportCategories: email_categories,
        scheduledReportTime: this.getDBValue(reportedTime, false),
        emailSubscribed: site.emailSubscribed,
        emailList: this.getDBValue(site.emailList, false),
        lastUpdatedAt: Date.now(),
        startIPAddress:site.startIPAddress,
        endIPAddress:site.endIPAddress,
        startIPAsNum:covertIPToNumber(site.startIPAddress),
        endIPAsNum:covertIPToNumber(site.endIPAddress),
         //ZAMS site field  
        address_line: site.address_line !== undefined ? site.address_line : '',
       postal_code: site.postal_code !== undefined ? site.postal_code : '',
       town: site.town !== undefined ? site.town : '',
       city: site.city !== undefined ? site.city : '',
       country: site.country !== undefined ? site.country : '',
       contact_first_name: site.contact_first_name !== undefined ? site.contact_first_name : '',
       contact_last_name: site.contact_last_name !== undefined ? site.contact_last_name : '',
       contact_phone_number: site.contact_phone_number !== undefined ? site.contact_phone_number : '',
       contact_mobile_number: site.contact_mobile_number !== undefined ? site.contact_mobile_number : '',
       contact_extension: site.contact_extension !== undefined ? site.contact_extension : '',
      //  alarm_timeout: site.alarm_timeout !== undefined ? site.alarm_timeout : 0,
       bluetooth_proximity_enabled: site.bluetooth_proximity_enabled !== undefined ? site.bluetooth_proximity_enabled : false,
      //  alarm_timeout_inherited: site.alarm_timeout_inherited !== undefined ? site.alarm_timeout_inherited : false,
       bluetooth_proximity_inherited: site.bluetooth_proximity_inherited !== undefined ? site.bluetooth_proximity_inherited : false,
       shift_duration: site.shift_duration !== undefined ? site.shift_duration : 0,
       shift_duration_inherited: site.shift_duration_inherited !== undefined ? site.shift_duration_inherited : false,
      }, options);
  };





  async deleteSites(tenantId, items) {

    let batch = this.firestore.batch();
    for (var i = 0; i < items.length; ++i) {

      var element = items[i];

      //Delete items one by one

      var doc = await this.firestore.collection("tenants")
        .doc(tenantId)
        .collection('SiteLocations')
        .doc(element.__name__).get();

      var site = doc.data().siteName;


      //Unassign the items associated with the site
      await this.unAssignSiteDependencies(tenantId, site);

      batch.delete(doc.ref);

    }

    await batch.commit();
  }

  TIME_AM = 1;
  TIME_PM = 2;


  getDBTimeZoneData(timeZoneId) {

    //Return the HRS, Minutes and dst observed from timezone
    //get the Timezone details from TimeZone
    var item = TimeZoneData.find((tz) =>
      tz.tzDatabaseName.toLowerCase() == timeZoneId.toLowerCase());

    return {
      //item.utcStd will have somethinglike 05:30
      //Take hrs & minutse form that
      hrs: item.utcStd.split(':')[0],
      mins: item.utcStd.split(':')[1],
      dst: item.dstObserved,
      utcStd: item.utcStd
    };

  }


  convertToCRON(reportedTime) {

    if (reportedTime === null) {
      //Both MINUTES & HRS are NULL.
      //So this can be considered NULL
      return null;
    }

    if ((typeof reportedTime === 'string' || reportedTime instanceof String) && reportedTime.indexOf('*') > -1) {
      return reportedTime;
    }

    var hrs = reportedTime.hrs;

    var cron = "";
    cron += ((reportedTime.minutes === null) ? "*" : reportedTime.minutes.toString()) + " ";
    cron += ((hrs === null) ? "*" : hrs.toString()) + " ";
    cron += " * * *";

    return cron;
  }

  async updateAllSites(tenantId, query, model, lastSiteName) {

    let batch = this.firestore.batch();

    const BATCH_SIZE = 490;

    //Save to CRON expression and save to DB
    var dbReportTime = this.convertToCRON(model.scheduledReportTime);
    //Get the timezone data
    var timeZone = this.getDBTimeZoneData(model.timeZone);

    let schReportTimeHrs = 0;
    let schReportTimeMts = 0;
    var utcTime = {};
    utcTime.hr = 0;
    utcTime.min = 0;
    if(model?.scheduledReportTime !== null) {
      schReportTimeHrs = model?.scheduledReportTime?.hrs;
      schReportTimeMts = model?.scheduledReportTime?.minutes
    }
    if(model.scheduledReportTime !== null) {
      utcTime = this.getUTCTime(model.timeZone, schReportTimeHrs, schReportTimeMts)
    }

    const snapshot = await query
      // .orderBy('reportedAt')
      .limit(BATCH_SIZE).get();
    const batchSize = snapshot.size;

    if (lastSiteName != null) {
      //There is a mac address to start with
      //This is called for next batch
      //So start the next batch from that
      query = query.startAfter(lastSiteName);
    }
    let email_categories = "";
      if(model.snapshotReportCategories['Select All'] == true)   // If select all is chosen
      {
        email_categories = "All";
      }
      else
      {
        for(let key in model.snapshotReportCategories){
          if(model.snapshotReportCategories.hasOwnProperty(key)){
            let value = model.snapshotReportCategories[key];
            if(value){
              email_categories = email_categories + key + ",";
            }
          }
        }
        email_categories = email_categories.substring(0,email_categories.length - 1);
      }
      if(email_categories === "")   // if no categories are chosen
      {
        email_categories = "Default";
      }

    if (batchSize === 0) {
      //All the records are updated
      return;
    } else {
      //Delete each record
      //Get the last Mac Address for the next query to start with
      //let snapshotData = snapshot.docs.map((doc) => doc.data());

      var lastSiteName = null;
      snapshot.docs.forEach((doc) => {

        //Update the siteName for each record
        batch.set(doc.ref, {
          ...doc.data(),
          lastUpdatedAt: Date.now(),
          //timeZone: model.timeZone,
          reportHoursActual: schReportTimeHrs,
          reportMinutesActual: schReportTimeMts,
          scheduledReportTime: dbReportTime,
          emailSubscribed: model.emailSubscribed,
          emailList: model.emailList,
          attachCSV: model.attachCSV,
          snapshotReportCategories: email_categories,
          //Reord the timezoneId and hrs, mins also
          timeZone: this.getDBValue(model.timeZone,false),
          reportUTCHours: utcTime.hr,
          reportUTCMinutes: utcTime.min,
          dstObserved: timeZone.dst
        });

        //Set the site location
        //this.updateSiteLocation(tenantId, oldSite, siteName);

        //Set the records address as last read mac access
        //lastMacAddress = doc.data().apMacAddress;
      });
      await batch.commit();
      //Call this recursively to delete the next set
      //await this.updateSiteForAllAccessPoints(tenantId, query, siteName, lastMacAddress);
    }

  }

  async updateSites(tenantId, sites, model) {
    // var options = new firebase.firestore.SetOptions();

    var options = {
      mergeFields: [
        "siteName",
        "displaySiteName",
        "address_line",
        "address2",
        "postal_code",
        "town",
        "city",
        "country",
        "contact_first_name",
        "contact_last_name",
        "contact_mobile_number",
        "contact_phone_number",
        "contact_extension",
        "contact_country",
        // "alarm_timeout",
        // "alarm_timeout_inherited",
        "lastUpdatedAt",
        "timeZone",
        "scheduledReportTime",
        "emailSubscribed",
        "emailList",
        'reportHoursActual',
        'reportMinutesActual',
        "reportUTCMinutes",
        "reportUTCHours",
        "startIPAddress",
        "endIPAddress",
        "startIPAsNum",
        "endIPAsNum",
        "attachCSV",
        "snapshotReportCategories"
      ]
    };
    //console.log(model,'mdv model');
    //console.log(sites,'mdv sites');
    let schReportTimeHrs = 0; let schReportTimeMts = 0;
    
    let utcTime = {};
    utcTime.hr = 0;
    utcTime.min = 0;
    var dbReportTime = "";
      
      
      if(model.scheduledReportTime !== null) {
        schReportTimeHrs = model.scheduledReportTime.hrs;
        schReportTimeMts = model.scheduledReportTime.minutes;
        utcTime = this.getUTCTime(model.timeZone, schReportTimeHrs, schReportTimeMts);
        dbReportTime = this.convertToCRON(model.scheduledReportTime);
      }
      let email_categories = "";
      if(model.snapshotReportCategories['Select All'] == true)   // If select all is chosen
      {
        email_categories = "All";
      }
      else
      {
        for(let key in model.snapshotReportCategories){
          if(model.snapshotReportCategories.hasOwnProperty(key)){
            let value = model.snapshotReportCategories[key];
            if(value){
              email_categories = email_categories + key + ",";
            }
          }
        }
        email_categories = email_categories.substring(0,email_categories.length - 1);
      }
      if(email_categories === "")   // if no categories are chosen
      {
        email_categories = "Default";
      }
        

    //}
    //const utcTime = this.getUTCTime(model.timeZone, model.scheduledReportTime.hrs, model.scheduledReportTime.minutes)
    
    //console.log(utcTime,'utcTime')
    //Save to CRON expression and save to DB
    var timeZone = this.getDBTimeZoneData(model.timeZone);

    for (var i = 0; i < sites.length; ++i) {

      //items will have the siteName and site
      var item = sites[i];


      //This needs to be changed
      var documentId = item.siteName;

      const updatedData = {
        //Don't capitalize Asset Name
        //Site Name

        siteName: model.siteName,
        displaySiteName: model.displaySiteName,
        address_line: model.address_line,
        address2: model.address2,
        postal_code: model.postal_code,
        town: model.town,
        city: model.city,
        country: model.country,
        contact_first_name: model.contact_first_name,
        contact_last_name: model.contact_last_name,
        contact_mobile_number: model.contact_mobile_number,
        contact_phone_number: model.contact_phone_number,
        contact_extension: model.contact_extension,
        contact_country: model.contact_country,
        // alarm_timeout: model.alarm_timeout,
        // alarm_timeout_inherited: model.alarm_timeout_inherited,

        lastUpdatedAt: Date.now(),
        //timeZone: model.timeZone,
        scheduledReportTime: dbReportTime,
        emailSubscribed: model.emailSubscribed,
        emailList: model.emailList,

        //Reord the timezoneId and hrs, mins also
        timeZone: this.getDBValue(model.timeZone,false),
        reportHoursActual: schReportTimeHrs,
        reportMinutesActual: schReportTimeMts,
        reportUTCHours: utcTime.hr,
        reportUTCMinutes: utcTime.min,
        dstObserved: timeZone.dst,
        attachCSV: model.attachCSV,
        snapshotReportCategories: email_categories,
        startIPAddress:model.startIPAddress,
        endIPAddress:model.endIPAddress,
        //startIPAsNum:covertIPToNumber(model.startIPAddress),
        startIPAsNum:model.startIPAsNum ? model.startIPAsNum : covertIPToNumber(model.startIPAddress) ,
        endIPAsNum:model.endIPAsNum ? model.endIPAsNum : covertIPToNumber(model.endIPAddress)
        //endIPAsNum:covertIPToNumber(model.endIPAddress)
      };
      const cleanModel = Object.fromEntries(
        Object.entries(updatedData).filter(([_, value]) => value !== undefined && value !== "")
      );
      await this.firestore
      .collection("tenants")
      .doc(tenantId)
      .collection("SiteLocations").doc(documentId).update(cleanModel)

      //Set the site location
      //this.updateSiteLocation(tenantId, oldSite, site);
    }
  }


  SITE_UNASSIGN_FIELDS = {
    mergeFields: [
      "siteName",
      "displaySiteName"
    ]
  };



  async unAssignSite(tenantId, siteName, collectionName) {

    //Get the items which have this site
    //and set the siteName to '' for those items


    const items = await this.firestore
      .collection("tenants")
      .doc(tenantId)
      .collection(collectionName)
      .where('siteName', '==', siteName).get();


    //Update the siteName to "" for each recrod
    for (var i = 0; i < items.docs.length; ++i) {
      //Update the item
      var doc = items.docs[i];


      if (collectionName == "Devices") {

        await this.firestore
          .collection("tenants")
          .doc(tenantId)
          .collection(collectionName).doc(doc.id).set({
            siteName: "",
            displaySiteName: ""
          }, this.SITE_UNASSIGN_FIELDS);

        //For devices, additonally update monotor fields also
        await this.firestore
          .collection("tenants")
          .doc(tenantId)
          .collection(collectionName).doc(doc.id).collection("Monitor").doc("Assignment").set({
            siteName: "",
            displaySiteName: ""
          }, this.SITE_UNASSIGN_FIELDS);
      }
      else {
        //Other collection. Update only @ root level
        await this.firestore
          .collection("tenants")
          .doc(tenantId)
          .collection(collectionName).doc(doc.id).set({
            siteName: "",
            displaySiteName: ""
          }, this.SITE_UNASSIGN_FIELDS);

      }
    }
  }


  static isValidEmail(email) {
    //Regex value to validate email
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    // Return true if the value is valid and false if not valid
    return emailPattern.test(email);
  }

  static isValidEmailList(emailList) {

    if (emailList == null || emailList == "") {
      //If it is blank consider that as true
      return true;
    }

    var emails = emailList.split(',');



    for (var i = 0; i < emails.length; ++i) {

      var email = emails[i].replace(/\s/g, '');
      //Validate the email value
      if (!SiteService.isValidEmail(email)) {
        //Atleast one email fails..
        return false;
      }
    }

    //Valid email
    return true;
  }

  //start of the IP address should be less than end
  static isValidIPRange(startIP, endIP){
    let startIPNum = covertIPToNumber(startIP);
    let endIPNum = covertIPToNumber(endIP);
    return startIPNum <= endIPNum ? true : false
  }

  hasDuplicateIP(inputStart, inputEnd, siteIPStart, siteIPEnd) {
    return (inputStart === siteIPStart || inputStart === siteIPEnd || inputEnd === siteIPStart || inputEnd === siteIPEnd)
  }

  isIPAddressInGivenRange(IPAddress, startIPAddress, endIPAddress) {
    let IPAddressNum = covertIPToNumber(IPAddress);
    let startIPNum = covertIPToNumber(startIPAddress);
    let endIPNum = covertIPToNumber(endIPAddress);
    return (startIPNum <= IPAddressNum) && (IPAddressNum <= endIPNum)
  }

  //IP Range of input site overlapping with other sites
  async ipRangeOverlapping(inputStart, inputEnd, sites) {
    return new Promise(async resolve => {
      console.log('input range ' + inputStart, inputEnd)
      let isOverlapping = false
      for (let eachSite of sites) {
        let site = eachSite;
        if (site.startIPAddress && site.endIPAddress) {
          console.log(site.siteName + ' existing site range ' + site.startIPAddress, site.endIPAddress)
          let promiseArr = []
          //check if inputStart IPAddress is falling in sites IP range
          promiseArr.push(this.isIPAddressInGivenRange(inputStart, site.startIPAddress, site.endIPAddress))
          //check if inputEnd IPAddress is falling in sites IP range
          promiseArr.push(this.isIPAddressInGivenRange(inputEnd, site.startIPAddress, site.endIPAddress))
          //check if startIPAddress of a site  is falling in input IP range
          promiseArr.push(this.isIPAddressInGivenRange(site.startIPAddress, inputStart, inputEnd))
          //check if startIPAddress of a site  is falling in input IP range
          promiseArr.push(this.isIPAddressInGivenRange(site.endIPAddress, inputStart, inputEnd))
          //check if input start and end IPAddress is not same as site's start and end IPAddress
          promiseArr.push(this.hasDuplicateIP(inputStart, inputEnd, site.startIPAddress, site.endIPAddress))
          isOverlapping = await Promise.all(promiseArr)
            .then(values => {
              return values.some(value => value === true)
            })
            .catch(err => {
              console.log('Inside ipRangeNotOverlapping', err)
              return true
            })
          if (isOverlapping) {
            console.log("overlapping occured for sitename",site)
            return resolve(isOverlapping)
          }
        }
      }
      return resolve(isOverlapping)
    })
  }

  async unAssignSiteDependencies(tenantId, site) {
    this.unAssignSite(tenantId, site, "Aps");
    this.unAssignSite(tenantId, site, "Devices");
    this.unAssignSite(tenantId, site, "Kiosk");
  }

  async deleteAllSites(tenantId, query) {
    let batch = this.firestore.batch();


    const BATCH_SIZE = 490;

    const snapshot = await query
      // .orderBy('reportedAt')
      .limit(BATCH_SIZE).get();
    const batchSize = snapshot.size;

    if (batchSize === 0) {
      //All the records are deleted

      return;
    } else {

      //Delete each record
      for (var i = 0; i < snapshot.docs.length; ++i) {
        var doc = snapshot.docs[i];

        var site = doc.data().siteName;
        batch.delete(doc.ref);


        //Unassign the items associated with the site
        this.unAssignSiteDependencies(tenantId, site);
      }
      await batch.commit();
      //Call this recursively to delete the next set
      this.deleteAllSites(tenantId, query);
    }
  }
}
